import { labelToTranslationKey } from 'utils';
import info from '../../assets/icons/info.svg';
import NoData from '../NoData';
import './TableCustomers.scss';
import { useTranslation } from 'react-i18next';

const TableCustomers = ({ data, columns, hasIconHeadrs, icons, helpTexts }) => {
  const { t } = useTranslation();
  return (
    <div className="TableCustomers">
      <table>
        <thead>
          <tr className="table_head_row">
            {data.headers.map((item, i) => {
              const hasIconIndex = hasIconHeadrs.indexOf(item);

              return (
                <th
                  key={`${item}${i}`}
                  className={
                    `${item === 'Next Item' ? 'highlight' : ''}` +
                    `${item === 'Filters' ? 'large' : ''}`
                  }
                >
                  {t(`user_based.${labelToTranslationKey(item)}`)}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {data.cells.map((item, i) => {
            return (
              <tr key={`${item.customer_name}${item.transactions}${i}`} className="table_body_row">
                {columns.map((column) => {
                  return (
                    <td key={column.header} className="table_td">
                      {column.header === 'Latest Transaction' ? (
                        <div className="latest_transaction">
                          {item.latest_transaction.at} <br />
                          <span>{item.latest_transaction.since}{t("user_based.days")}</span>
                        </div>
                      ) : item[column.cell] != null && column.header != 'Latest Transaction' ? (
                        <p className="itemText">{item[column.cell]}</p>
                      ) : (
                        '-'
                      )}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
      {data.cells.length === 0 && (
        <div className="no-data">
          <NoData />
        </div>
      )}
    </div>
  );
};

export default TableCustomers;
